import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, ArrowBtn, PageHero, ChainFlow } from '../components/bits';
import { useLead } from '../components/LeadModal';

const EVIDENCE = ['Project history', 'Technical outputs', 'Digital assets', 'Campaign results', 'Analytics', 'Commercial activity', 'Performance records'];

const VALUE = [
  'Reduce uncertainty around emerging talent',
  'Observe work before making hiring decisions',
  'Access specialised digital capabilities',
  'Build a longer-term talent pipeline',
  'Connect hiring with project-based evaluation',
];

export default function Talent() {
  const { open } = useLead();
  return (
    <div data-testid="talent-page">
    <SEO title="Talent Acquisition" description="See capability before you hire it — evidence-backed digital talent from the DITEC ecosystem." />
      <PageHero
        ck="talent"
        tag="Talent Acquisition Solution"
        lines={<>See Capability <span className="font-serif italic font-normal text-electric">Before You Hire It.</span></>}
        intro="Traditional recruitment often starts with qualifications. DITEC adds evidence."
      >
        <ArrowBtn onClick={() => open('Talent Acquisition')} variant="primary" testId="talent-cta-access">Access Talent</ArrowBtn>
      </PageHero>

      <section className="bg-paper py-20 sm:py-28">
        <div className="wrap grid gap-12 lg:grid-cols-2">
          <div>
            <SectionTag>01 — The Talent Ecosystem Can Include</SectionTag>
            <div className="mt-10 space-y-3">
              {EVIDENCE.map((e, i) => (
                <Reveal key={e} delay={i * 0.04} className="flex touch-target items-center gap-4 rounded-2xl border border-navy/10 bg-white px-6 py-4">
                  <span className="font-mono text-xs text-electric">0{i + 1}</span>
                  <span className="text-sm font-semibold tracking-tight sm:text-base">{e}</span>
                </Reveal>
              ))}
            </div>
          </div>
          <div>
            <SectionTag>02 — Enterprise Value</SectionTag>
            <div className="mt-10 rounded-3xl bg-navy p-8 text-white sm:p-10">
              <ul className="space-y-4">
                {VALUE.map((v) => (
                  <li key={v} className="flex items-start gap-3 text-sm leading-relaxed text-white/80 sm:text-base">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />{v}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-28">
        <div className="wrap">
          <SectionTag>03 — Talent Workflow</SectionTag>
          <Reveal delay={0.08} className="mt-10">
            <ChainFlow steps={['Requirement', 'Capability Mapping', 'Candidate Matching', 'Evaluation', 'Engagement', 'Deployment', 'Performance Record']} testId="talent-flow" />
          </Reveal>
          <Reveal delay={0.12} className="mt-10"><ArrowBtn onClick={() => open('Talent Acquisition')} variant="navy" testId="talent-cta-bottom">Access Talent</ArrowBtn></Reveal>
        </div>
      </section>
    </div>
  );
}
